<template>
  <figure
    v-parallax
    v-lazy-loading>
    <img :data-src="url" src="" alt="">
  </figure>
</template>

<script>

export default {
  name: 'GridFigure',
  props: {
    url: {
      type: String,
      required: true,
    },
  },
};
</script>

<style scoped lang="scss">
figure {
  position: relative;
  width: 80vw;
  height: 113vw;

  overflow: hidden;
  will-change: transform;
  background-color: rgba(255, 255, 255, 0.7);

  @include mq(ipadP) {
    width: 65vw;
    height: 95vw;
  }

  @include mq(ipadL) {
    width: auto;
    height: auto;
  }
}

img {
  position: absolute;
  top: -12.5%;
  left: -12.5%;
  width: 125%;
  height: 125%;

  @include mq(ipadL) {
    position: relative;
  }
}
</style>
